import gql from "graphql-tag";

import { Fragment, Activity } from "../types";
import { COMPANY_MINIMAL_FRAGMENT, CompanyMinimalFragment } from "./Company";
import { ContractMinimalFragment, CONTRACT_MINIMAL_FRAGMENT } from "./Contract";
import {
  ContractTemplateMinimalFragment,
  CONTRACT_TEMPLATE_MINIMAL_FRAGMENT,
} from "./ContractTemplate";
import {
  CampaignMinimalFragment,
  CAMPAIGN_MINIMAL_FRAGMENT,
} from "./Campaign";
import { MadMinimalFragment, MAD_MINIMAL_FRAGMENT } from "./Mad";
import { REPORT_FRAGMENT } from "./Report";
import { TEMPLATE_FRAGMENT } from "./Template";
import { UserMinimalFragment, USER_MINIMAL_FRAGMENT } from "./User";
import { GROUP_FRAGMENT, GroupFragment } from "./Group";

//todo comapny frag
export const ACTIVITY_FRAGMENT = gql`
  fragment ActivityFragment on Activity {
    id
    key
    createdAt
    updatedAt
    owner {
      ...UserMinimalFragment
    }
    recipientType
    recipient {
      ... on Company {
        ...CompanyMinimalFragment
      }
      ... on Mad {
        ...MadMinimalFragment
      }
      ... on Campaign {
        ...CampaignMinimalFragment
      }
    }
    trackableType
    trackable {
      ... on Company {
        ...CompanyMinimalFragment
      }
      ... on User {
        ...UserMinimalFragment
      }
      ... on Mad {
        ...MadMinimalFragment
      }
      ... on Campaign {
        ...CampaignMinimalFragment
      }
      ... on ContractTemplate {
        ...ContractTemplateMinimalFragment
      }
      ... on Template {
        ...TemplateFragment
      }
      ... on Report {
        ...ReportFragment
      }
      ... on Contract {
        ...ContractMinimalFragment
      }
      ... on Group {
        ...GroupFragment
      }
    }
  }

  ${GROUP_FRAGMENT}
  ${COMPANY_MINIMAL_FRAGMENT}
  ${MAD_MINIMAL_FRAGMENT}
  ${CONTRACT_MINIMAL_FRAGMENT}
  ${CONTRACT_TEMPLATE_MINIMAL_FRAGMENT}
  ${TEMPLATE_FRAGMENT}
  ${REPORT_FRAGMENT}
  ${CAMPAIGN_MINIMAL_FRAGMENT}
  ${USER_MINIMAL_FRAGMENT}
`;

export type ActivityFragment = Fragment<Activity, Activity>;
